export default __webpack_public_path__ + "static/media/Angel.8a79451a.jpg";